import { z } from 'zod';
export const revokeAccountBadgesBulkActionName = 'revokeAccountBadges';
export const revokeAccountBadgesBulkActionRequestSchema = z.object({
    badgeId: z.string().uuid(),
    revokedBadgeReasonsClassifierId: z.string().uuid(),
    revokeReasonDescription: z.string().optional(),
    filter: z.custom(),
});
export const partialRevokeAccountBadgesBulkActionRequestSchema = revokeAccountBadgesBulkActionRequestSchema.omit({ filter: true });
